/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Carrier_Allow_InspectionInputs */

const vi_carrier_allow_inspection = /** @type {(inputs: Carrier_Allow_InspectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xem hàng`)
};

/**

* @param {Carrier_Allow_InspectionInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const carrier_allow_inspection = /** @type {((inputs?: Carrier_Allow_InspectionInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Carrier_Allow_InspectionInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_carrier_allow_inspection(inputs)
});